/* NaturoBest link-in-bio page.
   1. Stamps utm_source=linkinbio on outbound own-domain links.
   2. Pushes a dataLayer event per [data-track] element. GTM is already on site.
   3. Forwards Klaviyo's own klaviyoForms submit event to GA4.
   Every section loads this file, hence the top-level guard; init() marks what it
   has handled so the theme editor can re-run it after a section re-render. */

(function () {
  'use strict';

  if (window.NBLinks) return;

  var UTM = {
    source: 'linkinbio',
    medium: 'social',
    campaign: 'bio-page'
  };

  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  /* UTM decoration */

  function decorateLinks(root) {
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-nbl-utm') === 'done') continue;
      a.setAttribute('data-nbl-utm', 'done');

      var raw = a.getAttribute('href') || '';
      // '#' resolves to the current URL, so it would become a real link.
      if (raw.charAt(0) === '#') continue;
      if (a.protocol !== 'http:' && a.protocol !== 'https:') continue;

      // Own links only. Same-host also covers relative URLs and preview domains.
      var isOwn = a.hostname === window.location.hostname ||
                  a.hostname.indexOf('naturobest.com') !== -1;
      if (!isOwn) continue;

      var url;
      try {
        url = new URL(a.href);
      } catch (e) {
        continue;
      }
      if (url.searchParams.get('utm_source')) continue;

      url.searchParams.set('utm_source', UTM.source);
      url.searchParams.set('utm_medium', UTM.medium);
      url.searchParams.set('utm_campaign', UTM.campaign);
      url.searchParams.set('utm_content', a.getAttribute('data-track') || 'unlabelled');
      a.href = url.toString();
    }
  }

  /* Click tracking */

  function bindTracking(root) {
    var els = root.querySelectorAll('[data-track]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-nbl-tracked') === 'done') continue;
      el.setAttribute('data-nbl-tracked', 'done');

      el.addEventListener('click', function () {
        push({ event: 'bio_link_click', link_id: this.getAttribute('data-track') });
      });
    }
  }

  /* Signup event */

  function bindKlaviyo() {
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.type !== 'submit') return;
      push({ event: 'bio_signup', link_id: 'signup', form_id: e.detail.formId });
    });
  }

  /* Boot ----------------------------------------------------------------- */

  function init() {
    var roots = document.querySelectorAll('.nbl');
    for (var i = 0; i < roots.length; i++) {
      decorateLinks(roots[i]);
      bindTracking(roots[i]);
    }
  }

  window.NBLinks = { init: init };
  bindKlaviyo();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: sections re-render on every settings change.
  document.addEventListener('shopify:section:load', init);
})();
